<template>
  <div class="card">
    <div class="card__header">
      <svg style="margin-right:14px" width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 20.4V1.6C1 1.26863 1.26863 1 1.6 1H13.2515C13.4106 1 13.5632 1.06321 13.6757 1.17574L16.8243 4.32426C16.9368 4.43679 17 4.5894 17 4.74853V20.4C17 20.7314 16.7314 21 16.4 21H1.6C1.26863 21 1 20.7314 1 20.4Z" stroke="#0E619F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M13 4.4V1.35355C13 1.15829 13.1583 1 13.3536 1C13.4473 1 13.5372 1.03725 13.6036 1.10355L16.8964 4.39645C16.9628 4.46275 17 4.55268 17 4.64645C17 4.84171 16.8417 5 16.6464 5H13.6C13.2686 5 13 4.73137 13 4.4Z" fill="black" stroke="#0E619F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M5 9H13" stroke="#0E619F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M5 17H13" stroke="#0E619F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M5 13H9" stroke="#0E619F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      {{ title }}
      <AppCheckbox :checked="false" @toggle-check="() => {}" style="margin-left:auto" />
    </div>
    <div class="card__content">
      <span class="card__content-name">
          {{ name }}
      </span>

      <span class="card__content-author">
        <b>Автор:</b>
        <span class="card__content-author" style="margin-left:13px">
          <div class="user-avatar dialog-avatar" style="margin-right:12px">
            <img v-if="author.avatar" :src="author.avatar">
            <img v-else src="/img/avatar-thumb.png">
          </div>

          <div style="color:#0e619f;font-weight:bold">
            {{ author.full_name }}
          </div>
        </span>
      </span>

      <span>
        <b>Создано:</b> {{ createdDate }}
      </span>

      <span>
        <b>Статус:</b> {{ status }}
      </span>

      <span style="color:black">
        <b>Вложения:</b>
        <svg style="margin-left:8px" width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 0H8.5V2.5H17V13H0V0Z" fill="#FAB959"/>
        </svg>
        {{ filesCount }} {{ formatedCount }}
      </span>

      <div class="card__controll">
        <svg
          @click="isControlsActive = !isControlsActive"
          class="ellipsis-icon"
          viewBox="0 0 23 4"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="2" cy="2" r="2" fill="currentColor" />
          <circle cx="11" cy="2" r="2" fill="currentColor" />
          <circle cx="21" cy="2" r="2" fill="currentColor" />
        </svg>

        <transition name="fade">
          <AppPopupControls
            v-if="isControlsActive"
            :active-buttons="{
              add: false,
              edit: true,
              remove: true
            }"
            @edit-this-item="() => {}"
            @remove-this-item="() => {}"
            class="card__controll-popup"
            @close="isControlsActive = false"
          />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import AppCheckbox from '@/components/page/input/AppCheckbox'
import AppPopupControls from '@/components/page/popup/AppPopupControls.vue'

export default {
  components: {
    AppCheckbox,
    AppPopupControls
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    author: {
      type: Object,
      default: () => ({})
    },
    name: {
      type: String,
      default: ''
    },
    createdDate: {
      type: String,
      default: ''
    },
    status: {
      type: String,
      default: ''
    },
    filesCount: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      isControlsActive: false
    }
  },
  computed: {
    formatedCount () {
      const modulo = this.filesCount % 10
      if (modulo === 1) return 'файл'
      if (modulo < 5 && modulo > 1) return 'файла'
      return 'файлов'
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  display: block;
  width: 336px;
  height: 340px;
  border-radius: 3px;

  .card__header {
    display: flex;
    align-items: center;
    height: 60px;
    padding: 0 20px;
    background: #F3F5FF;
    border-radius: 3px 0px 0px 0px;
    color: #0E619F;
  }

  .card__content {
    display: flex;
    flex-direction: column;
    height: calc(100% - 60px);
    border-bottom: 1px solid #c4c4c4;
    border-right: 1px solid #c4c4c4;
    border-left: 1px solid #c4c4c4;
    padding: 20px 19px;
    row-gap: 20px;
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 0.04em;
    color: #697178;

    .card__content-name {
      font-weight: bold;
      color: #0e619f;
    }

    .card__content-author {
      display: flex;
      align-items: center;
    }

    b {
        color: #697178;
    }

    .card__controll {
      position: relative;
      display: flex;
      width: 100%;
      margin-top: auto;

      svg {
        margin-left: auto;
        height: 10px;
        cursor: pointer;
      }

      .card__controll-popup {
        position: absolute;
        right: -5px;
        top: calc(100% + 10px);
      }
    }
  }
}
</style>
